import { render, staticRenderFns } from "./MedicineSummaryInfo.vue?vue&type=template&id=4165353a"
import script from "./MedicineSummaryInfo.vue?vue&type=script&lang=js"
export * from "./MedicineSummaryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports